module.exports = __webpack_public_path__ + "assets/grass-curve-top.667b6de9.svg";